export default "__VITE_ASSET__DmumxA6e__"